import { gql } from "apollo-boost";


export const PRESINGED_URL = gql`
mutation Mutation($fileName: String!, $mimeType: String!) {
  preSignedUrl(fileName: $fileName, mimeType: $mimeType) {
    url
  }
}
`;